export default __webpack_public_path__ + "static/media/691.ec27598b.png";